export default {
  "systemLogs": "System Logs",
  "auditEvents": "Audit Events",
  "applicationLogs": "Application Logs",
  "hour": "1 hour",
  "day": "24 hours",
  "week": "7 days",
  "month": "30 days",
  "all": "All",
  "off": "Off",
  "table": "Table",
  "live": "Live",
  "refresh": "Refresh",
  "loading": "Loading…",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "testEvent": "Test Event",
  "export": "Export",
  "connecting": "Connecting",
  "connected": "Connected",
  "reconnecting": "Reconnecting",
  "paused": "Paused",
  "error": "Error",
  "eventId": "Event ID",
  "source": "Source",
  "user": "User",
  "ipAddress": "IP Address",
  "route": "Route",
  "component": "Component",
  "requestId": "Request ID",
  "jobId": "Job ID",
  "liveFeed": "Live Feed",
  "allCategories": "All categories",
  "allLevels": "All levels",
  "allSources": "All sources",
  "resume": "Resume",
  "pause": "Pause",
  "clear": "Clear",
  "copy": "Copy",
  "reconnect": "Reconnect",
  "liveStream": "Audit live event stream",
  "noEvents": "No events yet.",
  "generateTest": "Generate test event",
  "connectingStream": "Connecting to audit stream…",
  "jumpLatest": "Jump to latest",
  "time": "Time",
  "category": "Category",
  "action": "Action",
  "level": "Level",
  "cmdDetails": "Cmd details",
  "eventDetail": "Event detail",
  "closeDetail": "Close detail",
  "details": "Details",
  "searchActions": "Search actions...",
  "prev": "Prev",
  "next": "Next",
  "purge": "Purge",
  "cancel": "Cancel",
  "purgeAria": "Purge audit logs",
  "history": "History",
  "active": "Active",
  "stopped": "Stopped",
  "pageDescription": "Audit events and application log viewer.",
  "auditDescription": "System audit events including authentication, settings changes, navigation, and job activity.",
  "auditLogging": "Audit Logging",
  "auditDisabled": "Disabled — {{categories}} events still recorded",
  "collectorActive": "Collector active",
  "collectorInactive": "Collector inactive",
  "categories_one": "{{displayCount}} category",
  "categories_other": "{{displayCount}} categories",
  "retention_one": "{{displayCount}} day retention",
  "retention_other": "{{displayCount}} days retention",
  "enableAuditHelp": "Enable audit logging to record authentication events, settings changes, navigation, admin actions, and job activity.",
  "alwaysAudited": "These categories remain enabled: {{categories}}. They record changes to the audit log itself, including deletions. Allowing an account to disable them would leave those actions unaudited.",
  "exportSourceHelp": "Only rows whose origin is \"{{source}}\" will be exported, matching the filter set on the panel.",
  "sourceOnly": "{{source}} only",
  "serverHint": "The server observed this action directly and wrote the row.",
  "clientHint": "A browser reported this and the server recorded the report. The account and address are the server's; the action is the browser's account of itself.",
  "unknownHint": "Recorded before event origin was tracked, so no origin is known for this row.",
  "olderHour": "Older than 1 hour",
  "olderDay": "Older than 24 hours",
  "olderWeek": "Older than 7 days",
  "olderMonth": "Older than 30 days",
  "allAuditLogs": "All audit logs",
  "purgeTitle": "Purge Audit Logs",
  "purgeLogs": "Purge Logs",
  "purgeAllConfirm": "This will permanently delete all audit log entries. This action cannot be undone.",
  "purgeRangeConfirm": "This will permanently delete audit log entries older than {{duration}}. This action cannot be undone.",
  "appsDescription": "Browse live and historical logs for installed applications via journalctl and log files.",
  "viewAs": "View as user:",
  "selfUser": "{{username}} (you)",
  "viewingApps": "Viewing {{username}}'s apps",
  "selectApp": "Select an application...",
  "appActive": "{{app}} (active)",
  "appStopped": "{{app}} (stopped)",
  "refreshApps": "Refresh Apps",
  "noApps": "No applications found. Applications are detected via their systemd service units.",
  "appsFailed": "Failed to load apps",
  "eventsFailed": "Failed to load audit events",
  "events_one": "{{displayCount}} event",
  "events_other": "{{displayCount}} events",
  "apps_one": "{{displayCount}} app",
  "apps_other": "{{displayCount}} apps",
  "files_one": "{{displayCount}} file",
  "files_other": "{{displayCount}} files",
  "viaAuth": "via {{type}}",
  "fields": "Fields: {{fields}}",
  "refused_one": "{{displayCount}} refused",
  "refused_other": "{{displayCount}} refused",
  "changed": "Changed: {{keys}}",
  "exitCode": "Exit {{code}}",
  "showing": "Showing {{from}}–{{to}} of {{total}}",
  "categoryAuth": "Authentication",
  "categorySettings": "Settings",
  "categorySecurity": "Security",
  "categorySystem": "System",
  "categoryUser": "User",
  "categoryUi": "Interface",
  "categoryJob": "Job",
  "categoryBackup": "Backup",
  "categoryCommand": "Command",
  "sourceServer": "Server",
  "sourceClient": "Client",
  "sourceUnknown": "Unknown",
  "levelInfo": "Info",
  "levelWarn": "Warning",
  "levelError": "Error",
  "seconds": "{{value}}s",
  "milliseconds": "{{value}} ms",
  "timeRange": "Time range",
  "exportFormat": "Export format",
  "audit.feedback.forbidden": "Forbidden",
  "audit.feedback.adminRequired": "Admin privileges required.",
  "audit.feedback.invalidQuery": "Invalid query parameters",
  "audit.feedback.userNotFound": "User not found",
  "audit.feedback.invalidCategory": "Invalid category",
  "audit.feedback.invalidLevel": "Invalid level",
  "audit.feedback.queryObject": "Query must be an object.",
  "audit.feedback.queryNumber": "Query parameter {{field}} must be a number.",
  "audit.feedback.queryInteger": "Query parameter {{field}} must be an integer.",
  "audit.feedback.queryString": "Query parameter {{field}} must be a string.",
  "audit.feedback.queryActionLength": "Query parameter action must contain at most 200 characters.",
  "audit.feedback.querySource": "Query parameter source must be server, client or unknown.",
  "audit.feedback.queryLimitMinimum": "Query parameter limit must be at least 1.",
  "audit.feedback.queryLimitMaximum": "Query parameter limit must be at most 200.",
  "audit.feedback.queryOffsetMinimum": "Query parameter offset must be at least 0.",
  "audit.feedback.category.media-management": "Media Management",
  "audit.feedback.category.media-servers": "Media Servers",
  "audit.feedback.category.media-requests": "Media Requests",
  "audit.feedback.category.download-clients": "Download Clients",
  "audit.feedback.category.indexers": "Indexers & Trackers",
  "audit.feedback.category.automation": "Automation & Tools",
  "audit.feedback.category.file-management": "File Management",
  "audit.feedback.category.readers": "E-Books & Comics",
  "audit.feedback.category.remote-access": "Remote Access",
  "audit.feedback.category.communication": "Communication",
  "audit.feedback.category.utilities": "Utilities & System",
  "audit.feedback.category.other": "Other"
} as const;
